<template>
  <div class="rounded-lg bg-profile-pic bg-no-repeat bg-cover bg-center"></div>
</template>
